export default "__VITE_ASSET__D0gGSr0S__"